import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import LeadPopup from "@/components/LeadPopup";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#FBF9F5]">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <LeadPopup />
    </div>
  );
}
